// extracted by mini-css-extract-plugin
export default {"active":"Exit_active__dHkNR","inActive":"Exit_inActive__Q+4iD","box":"Exit_box__XrT+C","iconWrapper":"Exit_iconWrapper__Q6khD","icon":"Exit_icon__KzpeX","label":"Exit_label__SBYDr"};